import { UserActions, UserActionsContainer } from '../components/PanelComponents/UserActionsContainer';
import { VendedorActions, VendedoresContainer } from '../components/PanelComponents/Vendedores/VendedoresContainer';
import { useAdminPanelUI } from '../hooks/useAdminPanelUI';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';

export function PanelContainer() {
    const { section, setSection, setUserAction, setVendedorAction } = useAdminPanelUI();

    return (
        <div className="flex flexs-col w-full h-full">
            <div className="border-r-2 border-gray-300 h-full w-[300px]">

                <div 
                    onClick={() => {
                        setSection("Users");
                        setUserAction(UserActions.UserList);
                    }}
                    className={`flex gap-x-2 justify-centers m-3 cursor-pointer hover:bg-gray-200 rounded px-2 py-1 ${section == "Users" ? "bg-gray-200" : ""}`}>
                    <GroupRoundedIcon sx={{ width: 30, height: 30 }}/>
                    <p className="font-semibold text-lg">Usuarios</p>
                </div>

                <div 
                    onClick={() => {
                        setSection("Vendedores");
                        setVendedorAction(VendedorActions.VendedoresList);
                    }}
                    className={`flex gap-x-2 justify-centers m-3 cursor-pointer hover:bg-gray-200 rounded px-2 py-1 ${section == "Vendedores" ? "bg-gray-200" : ""}`}>
                    <AttachMoneyRoundedIcon sx={{ width: 30, height: 30 }}/>
                    <p className="font-semibold text-lg">Vendedores</p>
                </div>

            </div>
            <div className="h-full w-full">
                {section == "Users"
                ? <UserActionsContainer />
                : <VendedoresContainer />
                }
            </div>
        </div>
    );
}